export default "__VITE_ASSET__uyxRyhxw$2I5bBOwG10uUA__"